export default (num) => {
  if (typeof num === 'number' || typeof num === 'undefined') {
    return num;
  } else {
    return parseFloat(num);
  }
};
